import React from "react";
import "./AppLayout.css";

const AppLayout = ({ children }) => {
  return (
    <div className="app-container">
      {/* HEADER */}
      <header className="app-header">
        <h1>nuChat</h1>
        <h6>Fast • Secure • Private</h6>
      </header>

      {/* MAIN CONTENT */}
      <main className="app-main">
        {/* We wrap children in a container to control max-width on large screens */}
        <div style={{ width: "100%", maxWidth: "1200px" }}>{children}</div>
      </main>

      {/* FOOTER */}
      <footer className="app-footer">
        &copy; {new Date().getFullYear()} nuChat • @Chetaa
      </footer>
    </div>
  );
};

export default AppLayout;
